import { connectScreenCloud } from "@screencloud/apps-sdk";
import { CLIENT, VERSION } from "./version.js";

let token = null;
const SERVICES_URL = "https://services.cetvnow.network/screencloud";
const SC_API_TOKEN =
  "a36c1ea8-f75a-49e4-b512-31d348c34e70:391a7c63d336e3b71e7bfcad04267d21";


function checkConfig(ext_id) {
  const config = JSON.parse(localStorage.getItem("config"));
  console.log("config", config);
  if (config && config.adServerURL && config.screenId && config.locationId) {
    console.log("config exists");
    window.location.href = `/player/index.html`;
  } else {
    console.log("config does not exist");
    getConfig(ext_id);
  }
}

//get the config
function getConfig(ext_id) {
  let url = `${SERVICES_URL}/config?ext_id=${ext_id}&client=${CLIENT}&version=${VERSION}`;

  fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }

      if (response.status === 404) {
        document.getElementById("message").innerText = "Screen not found.";
        return;
      }

      document.getElementById("message").innerText =
        "Error getting configuration.";

      throw new Error("Error getting configuration.");
    })
    .then((data) => {
      if (!data) {
        document.getElementById("message").innerText = "Screen not found.";
        return;
      }
      data.token = token;
      document.getElementById("message").innerText = "Done. Please wait.";
      localStorage.setItem("config", JSON.stringify(data));
      window.location.href = "/player/index.html";
    })
    .catch((error) => {
      console.log("error", error);
      document.getElementById("message").innerText =
        "Error getting configuration.";
    });
}


//start function to connect to ScreenCloud
async function start() {
  const sc = await connectScreenCloud();
  const scContext = sc.getContext();
  const ext_id = scContext.screenId;

  //const ext_id = "762b47d3-483b-4f22-adc2-391dccd900e9";
  
  document.getElementById("version").innerText =
    `Player Version: ${CLIENT}-${VERSION}`;
  if (!ext_id) {
    document.getElementById("message").innerText = "ScreenCloud ID not found.";
    return;
  }

  //let clear the config if there is one and start over
  localStorage.removeItem("config");

  //before checking config, let's sleep for a min so the player version can be checked
  await new Promise((resolve) => setTimeout(resolve, 4000));

  checkConfig(ext_id);
}

start();
